import React, { useRef, useLayoutEffect, useContext, useState } from 'react';
import { StyleSheet, View, Text, Dimensions, TouchableOpacity, Image, Animated } from 'react-native';
import { styled } from "@mui/material/styles";
import Slider from "@mui/material/Slider";
import { ActivityContext } from "../../../Activities";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "../../../../Utils/responsive";
import ContinueButton from "../../../../Components/ContinueButton";
const iOSBoxShadow =
  "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)";

const textColor = "var(--text-color-default)";
const buttonColor = "var(--game-accent-color-2-exp)";
const buttonTextColor = "var(--module-overlay-text-color-exp)";
const sliderTrackColor = "var(--game-accent-color-exp)";
const inverseTextColor = "var(--module-overlay-text-color-exp)";

const IOSSlider = styled(Slider)(({ theme }) => ({
  color: sliderTrackColor,
  height: 2,
  padding: "15px 0",
  marginBottom: "0.5rem",
  "& .MuiSlider-thumb": {
    height: 50,
    width: 50,
    backgroundColor: buttonColor,
    boxShadow: iOSBoxShadow,
    // marginTop: -28,
    // marginLeft: -18,
    "&:focus, &:hover, &.Mui-active": {
      boxShadow:
        "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: iOSBoxShadow,
      },
    },
  },
  active: {},
  "& .MuiSlider-valueLabel": {
    // left: "calc(-17% + 17px)",
    height: 32,
    top: 42,
    fontSize: 20,
    fontWeight: "900",
    background: "transparent",
    color: inverseTextColor,
  },
  "& .MuiSlider-track": {
    height: 2,
    // backgroundColor: "var(--text-color-default)",
    // borderColor: "var(--text-color-default)",
  },

  "& .MuiSlider-rail": {
    height: 5,
    opacity: 1,
    backgroundColor: sliderTrackColor,
  },
}));

export default function CustomizedSlider(props) {
  const animation = useRef(new Animated.Value(0)).current;
  const [hide, setHide] = useState(true);
  const [sliderValue, setSliderValue] = useState(0);
  const resultContext = useContext(ActivityContext);
  const [resindex, setResIdex] = useState(0);

  const handleChange = (event, newValue) => {
    if (newValue >= 0 && newValue < 1) {
      setSliderValue(newValue);
      setResIdex(0);
    } else if (newValue >= 1 && newValue < 3) {
      setSliderValue(newValue);
      setResIdex(1);
    } else if (newValue >= 3 && newValue < 5) {
      setSliderValue(newValue);
      setResIdex(2);
    } else if (newValue >= 5 && newValue < 10) {
      setSliderValue(newValue);
      setResIdex(3);
    } else if (newValue >= 10) {
      setSliderValue("10+");
      setResIdex(4);
    }
  };
  useLayoutEffect(() => {
    let check;
    let moduleIdExep = resultContext.result.modules.filter(
      (mod) => mod.moduleid === props.moduleObject.moduleid
    );
    if (props.moduleObject.questions[props.moduleIndex].askif) {
      if (props.moduleObject.questions[props.moduleIndex].askif.op === "OR") {
        props.moduleObject.questions[props.moduleIndex].askif.answers.forEach(
          (val) => {
            moduleIdExep[0].responses.forEach((data) => {
              if (val.qid === data.qid) {
                check = props.moduleObject.questions[
                  props.moduleIndex
                ].askif.answers.find((cc) => cc.respid === data.respid);
              }
            });
            if (check) {
            } else {
              props.selectAnswerHandler(
                props.moduleObject.moduleid,
                props.moduleObject.questions[props.moduleIndex].qid,
                props.moduleObject.questions[props.moduleIndex].answers[0]
                  .respid
              );
              props.setSkippedQuestion(true);
              props.Refresh();
            }
          }
        );
      }
      if (props.moduleObject.questions[props.moduleIndex].askif.op === "AND") {
        props.moduleObject.questions[props.moduleIndex].askif.answers.forEach(
          (val) => {
            moduleIdExep[0].responses.forEach((data) => {
              if (val.qid === data.qid) {
                if (val.respid === data.respid) {
                } else {
                  props.selectAnswerHandler(
                    props.moduleObject.moduleid,
                    props.moduleObject.questions[2].qid,
                    props.moduleObject.questions[2].answers[0].respid
                  );
                  props.Refresh();
                }
              }
            });
          }
        );
      }
    }
    Animated.timing(animation, {
      toValue: 1,
      duration: 1000,
    }).start(() => setHide(false));
  }, []);

  const nextPage = () => {
    setHide(true);
    props.selectAnswerHandler(
      props.moduleObject.moduleid,
      props.moduleObject.questions[props.moduleIndex].qid,
      props.moduleObject.questions[props.moduleIndex].answers[resindex].respid
    );
    Animated.timing(animation, {
      toValue: 0,
      duration: 1000,
    }).start(() => props.Refresh());
  };

  return (
    <Animated.View style={[styles.content, { opacity: animation }]}>
      <Text style={styles.customText}>
        {props.moduleObject.questions[2].text}
        {"\n"}
        (move the slider)
      </Text>
      <View style={styles.slider}>
        <IOSSlider
          aria-label="ios slider"
          defaultValue={0}
          max={10}
          onChange={handleChange}
          valueLabelFormat={sliderValue}
          valueLabelDisplay="on"
        />
      </View>
      <View style={{ margin: 5 }}></View>
      <View>
        <ContinueButton text="Continue" onClick={nextPage} disabled={hide} />
      </View>
    </Animated.View>
  );
}
const styles = StyleSheet.create({
  content: {
    height: "100vh",
    width: "100vw",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  customText: {
    position: "relative",
    width:
      Dimensions.get("screen").width > 1300
        ? wp("28%")
        : Dimensions.get("screen").width > 700
        ? wp("43%")
        : wp("89%"),
    Height: hp("24.3%"),
    fontSize:
      Dimensions.get("screen").width > 1000
        ? 24
        : Dimensions.get("screen").width < 350
        ? 16
        : 22,
    textAlign: "center",
    color: textColor,
    marginBottom: hp("4%"),
    // fontFamily: 'InfraSemiBold',
    lineHeight:
      Dimensions.get("screen").width > 1000
        ? 32
        : Dimensions.get("screen").width < 350
        ? 24
        : 26,
    fontWeight: "var(--font-weight-semi-bold)",
  },
  slider: {
    width:
      Dimensions.get("screen").width > 1300
        ? wp("30%")
        : Dimensions.get("screen").width > 700
        ? wp("28%")
        : wp("80%"),
    marginRight: Dimensions.get("screen").width < 350 ? 7 : 0,
  },
  button: {
    width: 115,
    height: 40,
    backgroundColor: buttonColor,
    alignItems: "center",
    justifyContent: "center",
    marginTop: hp("3%"),
  },
  arrow: {
    alignSelf: "center",
    width: 18,
    height: 18,
    resizeMode: "contain",
  },
  buttonText: {
    // fontFamily: 'InfraSemiBold',
    fontSize: 16,
    lineHeight: 24,
    textAlign: "center",
    color: buttonTextColor,
    fontWeight: "var(--font-weight-semi-bold)",
  },
});
